import React, { Component } from 'react'
import { connect } from 'react-redux';

import { initForm, updateInputValue as change, selectFormValue } from "app/reducers/form"
import { GradientDefs, GradientFillUrl } from "shape-edit/forms/fields";
import ImageFromElementsShape from 'shape-entities/types/ImageFromElementsShape';
import { RandomProduct } from "shape-edit/types";
import { imageFromElementsGetImageBlob } from 'app/helpers/api';
import { AxiosResponse } from 'axios';
import { getFormName } from 'shape-edit/forms/helpers';

interface Props {
    data: ImageFromElementsShape
    randomProduct: RandomProduct
    isAlt: boolean
    change: typeof change
}

class ImageFromElementsSvg extends Component<Props> {
    constructor(props) {
        super(props)
    }

    getContentFromProps = (props: Props) : string|null => {
        const shape: ImageFromElementsShape = props.data
        const content =  shape.image_xml_element && props.randomProduct.serialized_data && typeof props.randomProduct.serialized_data[shape.image_xml_element] !== 'undefined' ? props.randomProduct.serialized_data[shape.image_xml_element] : null

        return Array.isArray(content) && typeof content[0] === 'string' ? content[0] : (typeof content === 'string' ? content : null)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps && (
            prevProps.randomProduct?.id !== this.props.randomProduct?.id ||
            prevProps.data.image_xml_element !== this.props.data.image_xml_element ||
            prevProps.data.imageBlob !== this.props.data.imageBlob
        )) {
            const thisContent = this.getContentFromProps(this.props)
            const prevContent = this.getContentFromProps(prevProps)
            if (thisContent !== prevContent) {  //only if content changed, not is_remove_background!! it is already changed in image-from-elmenet-form.tsx!
                this.updateImageBlob()
            }
        }
    }

    updateImageBlob = () => {
        const shapeObject: ImageFromElementsShape = this.props.data
        const content = this.getContentFromProps(this.props)

        imageFromElementsGetImageBlob(this.props.randomProduct?.id, content, shapeObject.is_remove_background, shapeObject.index)
            .then((response: AxiosResponse<string>) => {
                const imageBlob = response.data
                const formName = getFormName(this.props.isAlt)

                console.debug(`updating image blob ${content} --> ${imageBlob}`)

                this.props.change(formName, `shapes.${shapeObject.index}`, {
                    ...shapeObject,
                    imageBlob: imageBlob,
                    is_remove_background: shapeObject.is_remove_background,
                })
            })
            .catch((error) => {
                console.error('imageFromElement: getImageBlob error', error)
            })
    }

    render() {
        const shapeObject: ImageFromElementsShape = this.props.data

        const content = this.getContentFromProps(this.props)

        const width = shapeObject.width ? parseInt(`${shapeObject.width}`) : 10
        const height = shapeObject.height ? parseInt(`${shapeObject.height}`) : 10

        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma
        const filter = isShadow ? `url(#shadow-${shapeObject.index})` : ''

        const shapeOpacity = shapeObject.opacity && shapeObject.opacity > 0 && shapeObject.opacity < 100 ? shapeObject.opacity / 100 : undefined

        return (
            <g className="draggable dynamic" width={width} height={height}>
                {isShadow &&
                    <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                        <feDropShadow
                            dx={shapeObject.shadow_xoffset}
                            dy={shapeObject.shadow_yoffset}
                            stdDeviation={shapeObject.shadow_sigma}
                            floodColor={shapeObject.shadow_color}
                            floodOpacity={1 - shapeObject.shadow_opacity / 100}
                        />
                    </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                    <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                <image
                    className='image-preview'
                    width={width}
                    height={height}
                    key={`${shapeObject.index}_${shapeObject.is_remove_background}_${shapeObject.is_remove_background && shapeObject.imageBlob ? shapeObject.imageBlob : content}`}
                    xlinkHref={shapeObject.is_remove_background && shapeObject.imageBlob ? shapeObject.imageBlob : content}
                    transform={`translate(${-shapeObject.width / 2},${-shapeObject.height / 2})`}
                    preserveAspectRatio={shapeObject.is_aspect_size_ratio ? 'xMidYMid meet' : 'none'}
                    filter={filter}
                    style={{
                        opacity: shapeOpacity
                    }}
                />

                {/* {shapeObject.image_xml_element &&
                    <text dominantBaseline="middle" textAnchor="middle">[{shapeObject.image_xml_element}]</text>
                } */}
            </g>
        )
    }
}

function mapStateToProps(state) {
    return {
        randomProduct: state.randomProduct,
        isAlt: state.isAlt,
    }
}
export default connect(mapStateToProps, {
    change,
})(ImageFromElementsSvg)